import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext, useMemo } from 'react';
import { useEditingProps, useGetZ3kObject } from '../utils/unpack-props';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { TrustPhonesInput } from './phones';
import { keysRadioTagsOptionsSelector } from 'console/device-settings/z3k/components/utils/z3k-selectors';
import { SettingFullRow } from 'console/device-settings/z3k/components/material-utils/settings-card/full-row';
import { Z3KSettingsEditor } from 'console/device-settings/z3k/provider/types';
import { MultipleSelectionTable, } from '../material-utils/multiple-selection-table/multiple-selection';
import { SettingContainer } from '../material-utils/settings-card/container';
import { Control } from 'console/shared/components/fields/control';
import { TextInputWrapper } from 'console/shared/components/fields/text';
import { PasswordInput } from 'console/shared/components/fields/text/password';
export const UserComponent = memo(function UserControlImpl() {
    const z3k_name = 'users';
    const item = useGetZ3kObject(z3k_name);
    const id = item.id;
    const { config } = useContext(Z3KSettingsEditor);
    const keys_radio_tags_options = keysRadioTagsOptionsSelector(config);
    const multipleSelectionTableOptions = useMemo(() => {
        return [
            {
                title: 'Список радиометок и ключей touchmemory',
                help_id: 'users_key_and_radiotag_list',
                z3k_field: 'key_and_radiotag_list',
                options: keys_radio_tags_options,
            },
        ];
    }, [item]);
    const nameEditingProps = useEditingProps(id, z3k_name, 'name');
    const passwordEditingProps = useEditingProps(id, z3k_name, 'password');
    const phoneEditingProps = useEditingProps(id, z3k_name, 'phone');
    return (_jsx(ErrorBoundary, { children: _jsxs(SettingContainer, { alignItems: "flex-end", children: [_jsx(Control, { label: "\u0418\u043C\u044F", field: TextInputWrapper, help_id: "users_name", ...nameEditingProps }), _jsx("form", { autoComplete: "off", children: _jsx(Control, { label: "\u041F\u0430\u0440\u043E\u043B\u044C \u0434\u043B\u044F \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0441 \u0434\u0440\u0443\u0433\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430", field: PasswordInput, help_id: null, ...passwordEditingProps }) }), _jsx(TrustPhonesInput, { ...phoneEditingProps }), _jsx(SettingFullRow, { children: _jsx(MultipleSelectionTable, { elements: multipleSelectionTableOptions, z3k_name: z3k_name, notification: false, help_id_second_column: "user_actions" }) })] }) }));
});
